module.exports = (s) => {
  return [
    {
      name: '渠道号',
      value: 'channel_alias',
    },
    {
      name: '渠道包名称',
      value: 'channel_package_name',
    },
    {
      name: '操作',
      width: '150',
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button', {
          props: {
            size: 'mini',
            type: 'primary',
          },
          on: {
            click: () => {
              s.onOpen(row);
            },
          },
        }, '选择渠道包');
        return ele;
      },
    },
  ];
};
